"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlWithLanguageId = exports.getMailToUrl = void 0;
exports.getMailToUrl = (email) => {
    return `mailto:${email}`;
};
exports.getUrlWithLanguageId = (url, languageId) => {
    return `${url}/${languageId}`;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL3V0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUdhLFFBQUEsWUFBWSxHQUFHLENBQUMsS0FBdUIsRUFBRSxFQUFFO0lBQ3RELE9BQU8sVUFBVSxLQUFLLEVBQUUsQ0FBQTtBQUMxQixDQUFDLENBQUE7QUFFWSxRQUFBLG9CQUFvQixHQUFHLENBQUMsR0FBbUIsRUFBRSxVQUF5QixFQUFFLEVBQUU7SUFDckYsT0FBTyxHQUFHLEdBQUcsSUFBSSxVQUFVLEVBQUUsQ0FBQztBQUNoQyxDQUFDLENBQUEifQ==